import 'bootstrap/dist/css/bootstrap.min.css';
import ITCLogo from '../../assets/Images/CommonImages/ITClogo.png';
import DriverAlerts from '../Dispatch/Alerts/DriverAlerts.js';
import APICom from "../../utils/helpers/APICom.js";
import React, { useState, useEffect, useRef } from 'react';
import {Button, Modal} from 'react-bootstrap';
import { Icon } from '@iconify/react/dist/iconify.js';
import HeadSetOffIcon from '@mui/icons-material/HeadsetOff';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import DownloadPhoneUtitlity from '@mui/icons-material/InstallMobile';
import LoggedInPerson from '@mui/icons-material/AssignmentInd';
import PersistStorage from '../../utils/helpers/PersistStorage.js';
import {
    getLastSeenDriverMessageID,
    getLastSoundedDriverMessageID,
    getPendingDriverMessageCount,
    hasAnyPendingDriverMessage,
    setLastSeenDriverMessageID,
    setLastSoundedDriverMessageID,
    setPendingDriverMessage
} from '../../utils/helpers/messagingNotificationState.js';
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { updateVExtension  } from "../../features/login/loginSlice";
import Messaging from '../Controls/Messaging.js';
import MDT_notification from '../../assets/Audio/MDT_notification.wav'
import ModuleSecurity from '../../utils/helpers/ModuleSecurity';


const HeaderComponent = ({affSelected, loginData}) => {
    // const { loginData } = useSelector((store) => store.login);

    const IsModuelAllowed_DriverMDTMessaging = ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_DriverMDTMessaging");
    const IsModuelAllowed_DriverRouteMessaging = ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_DriverRouteMessaging");
    const IsModuelAllowed_DisplayAlerts = ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_DisplayAlerts");
    
    

    const [showDriverAlerts, setShowDriverAlerts] = useState(false);
    const [showAlertsTitleHTML, setShowAlertsTitleHTML] = useState(null);
    const [winWidth, setWinWidth] = useState(window.innerWidth);
    const [AffChange, setAffChange] = useState(0);
    const [showMessaging, setShowMessaging] = useState(false);
    const [showRouteMessaging, setShowRouteMessaging] = useState(false);
    const [notifIcon, setNotifIcon] = useState(localStorage.getItem('notifIcon') === 'true' ? true : false);
    const [notifCount, setNotifCount] = useState(getPendingDriverMessageCount());
    const [showCustomerManagement, setShowCustomerManagement] = useState(false);
    const [showNotifications, setshowNotifications] = useState(false);
    const AffiliateIDForAlertsRef = useRef(null);
    const AlertsRef = useRef(null);
    const xCancelSourceForGrid = useRef(null);
    const UserLoginData = useRef([]);
    const prevVeh = useRef();
    const lastMessID = useRef(-1);
    const defaultDocumentTitle = useRef(document.title);
    const [isFetching, setIsFetching] = useState(false);
    const isFetchingRef = useRef(false);
    const [showModal, setShowModal] = useState(false);
    const {GlobalASCSData} = useSelector((store) => store.combinedata);
    const dispatch = useDispatch();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showExtInput, setShowExtInput] = useState(false);
    const [showExtButton, setShowExtButton] = useState(true);
    const [asteriskExt, setAsteriskExtension] = useState('');
    const dropdownRef = useRef(null);
    const PhoneUtilityDownloadLinkRef = useRef(null);
    PhoneUtilityDownloadLinkRef.current = GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "phoneutility_downloadlink") ? GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "phoneutility_downloadlink").value : "";
    if(PhoneUtilityDownloadLinkRef.current.includes("-"))
    {
        PhoneUtilityDownloadLinkRef.current = PhoneUtilityDownloadLinkRef.current.split("-")[0] + ".zip";
    } 

    const resolveMessagingAffiliateId = () => {
        const propAffiliate = parseInt(affSelected, 10);
        if (!isNaN(propAffiliate) && propAffiliate > 0) {
            return propAffiliate;
        }

        const passedAffiliate = parseInt(PersistStorage.retrieve("passedAff", true), 10);
        if (!isNaN(passedAffiliate) && passedAffiliate > 0) {
            return passedAffiliate;
        }

        const familyAffiliate = parseInt(PersistStorage.retrieve("_SelectedFamilyAffiliates", false), 10);
        if (!isNaN(familyAffiliate) && familyAffiliate > 0) {
            return familyAffiliate;
        }

        const loginAffiliate = parseInt(loginData?.UserAffiliateList?.split(",")?.[0], 10);
        if (!isNaN(loginAffiliate) && loginAffiliate > 0) {
            return loginAffiliate;
        }

        return 0;
    };

    const resolveMessagingAffiliateIds = () => {
        const loginAffiliateIds = String(loginData?.UserAffiliateList ?? "")
            .split(",")
            .map((item) => parseInt(item, 10))
            .filter((item) => !isNaN(item) && item > 0);

        if (loginAffiliateIds.length > 0) {
            return [...new Set(loginAffiliateIds)];
        }

        const resolvedAffiliate = resolveMessagingAffiliateId();
        return resolvedAffiliate > 0 ? [resolvedAffiliate] : [];
    };

    const refreshMessagingNotificationState = () => {
        const count = getPendingDriverMessageCount();
        setNotifCount(count);
        setNotifIcon(count > 0 || localStorage.getItem('notifIcon') === 'true');
        if (!window.location.href.toLowerCase().includes("messaging")) {
            document.title = count > 0 ? `(${count}) New Driver MDT Messages` : defaultDocumentTitle.current;
        }
    };

    const renderDriverMdtMessagingIcon = () => {
        if (!IsModuelAllowed_DriverMDTMessaging) {
            return null;
        }

        const isHighlighted = notifIcon || notifCount > 0;
        return (
            <span className={`text-center my-auto mx-1 p-1 circle ${isHighlighted ? "" : "bg-white"}`}
                style={{
                    cursor: "pointer",
                    width: "35px",
                    height: "35px",
                    backgroundColor: isHighlighted ? "#f7a51a" : undefined,
                    position: "relative",
                    boxShadow: isHighlighted ? "0 0 0 2px rgba(247,165,26,0.35), 0 0 10px rgba(247,165,26,0.85)" : undefined
                }}
                title={"Driver MDT Messaging"}
                onClick={() => { setShowMessaging(true); }}
            >
                <Icon className='text-dark my-auto' style={{ width: "20px", minWidth: "20px", height: "20px" }} icon={'bx:chat'} />
                {notifCount > 0 && (
                    <span
                        className="position-absolute bg-danger text-white rounded-circle fw-bold"
                        style={{
                            top: "-7px",
                            right: "-7px",
                            minWidth: "18px",
                            height: "18px",
                            lineHeight: "18px",
                            fontSize: "11px"
                        }}
                    >
                        {notifCount > 99 ? "99+" : notifCount}
                    </span>
                )}
            </span>
        );
    };

    const handleShowAlertCounts = async(aff)=>{
        try{
            let data = {
                "selectedAffiliate": (aff?
                    aff:(UserLoginData.current? parseInt(UserLoginData.current.UserAffiliateList?.split(",")[0]):parseInt(loginData.UserAffiliateList?.split(",")[0])))
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            let response = await APICom.fetchData("main","TripActions/GetAlarmsSummary", "post", {}, data, xCancelSourceForGrid.current, false);
            if(response.data && response.data.AllAlerts.length > 0)
            {
                // let countDataArr = response.data.AllAlerts[0];
                let driverPenaltyCountForAff = 0;
                let emergencyCount = 0;
                let noshowCount = 0;
                let othersCount = 0;
                let lateCount = 0;
                let deviceCount = 0;
                let deviceLockedForAff = 0;
                let alarmsArr = response.data.Alarms;
                let alertsArr = response.data.AlertDetails;
                let driverPenaltyArr = (Array.isArray(response.data.DriverPenalty) && response.data.DriverPenalty.length > 0 ? response.data.DriverPenalty[0] : null);
                let deviceLockArr = (Array.isArray(response.data.DeviceLocked) && response.data.DeviceLocked.length > 0 ? response.data.DeviceLocked[0] : null);
                let LateTripsArr = (Array.isArray(response.data.LateDetails) && response.data.LateDetails.length > 0 ? response.data.LateDetails[0] : null);
                
                driverPenaltyCountForAff = (driverPenaltyArr && driverPenaltyArr.DriverPenaltyCount? parseInt(driverPenaltyArr.DriverPenaltyCount) : 0);
                deviceLockedForAff = (deviceLockArr && deviceLockArr.DeviceLockedCount? parseInt(deviceLockArr.DeviceLockedCount) : 0);
                deviceCount = (deviceLockArr && deviceLockArr.DeviceDetailsCount? parseInt(deviceLockArr.DeviceDetailsCount) : 0);
                lateCount = (LateTripsArr && LateTripsArr.LateAlertCount? parseInt(LateTripsArr.LateAlertCount) : 0);
                
                if(alarmsArr && alarmsArr.length > 0)
                {
                    othersCount += alarmsArr[0].Other;
                    emergencyCount += alarmsArr[0].EMERGENCY;
                    noshowCount += alarmsArr[0].NOSHOWREQ;
                }
                else if(alertsArr && alertsArr.length > 0)
                {
                    othersCount += alertsArr[0].AlertCount;
                }

                let alertsTitleHTML = function(index){
                    return(
                            <span key={index} style={{fontSize:"small"}}> 
                            {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Customer Management"} onClick={()=>{setShowCustomerManagement(true);}}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'ix:customer'}/> 
                            </span> */}

                            {renderDriverMdtMessagingIcon()}
                           
                            {IsModuelAllowed_DriverRouteMessaging == true &&
                                (<span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                    style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver Route Messaging"} onClick={()=>{setShowRouteMessaging(true);}}
                                >
                                    <PermPhoneMsgIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                                </span>
                            )}

                            <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Robo Notifications"} onClick={()=>{setshowNotifications(true);}}
                            >
                                <EditNotificationsIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                            </span>
                            
                            {IsModuelAllowed_DisplayAlerts == true &&
                                (
                                    <span className='text-dark bg-white small px-2 py-1' onClick={handleOpenAlerts} style={{cursor:'pointer', borderRadius:"10px"}}>{"ALERTS"}</span>
                                )
                            }
                                <span className='text-white mx-1 px-1 fw-normal'>
                                    <span title={"Emergency Alert Count"} style={{fontSize:"small"}}>
                                        {"| EM"} 
                                        {emergencyCount > 0 ? 
                                            <span className='fw-bold text-danger mx-1'>{emergencyCount}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    <span title={"No-Show Alert Count"} style={{fontSize:"small"}}>
                                        {"| NS"} 
                                        {noshowCount > 0 ? 
                                            <span className='fw-bold text-danger mx-1'>{noshowCount}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    <span title={"Late Pickup Alert Count"} style={{fontSize:"small"}}>
                                        {"| LT"} 
                                        {lateCount > 0 ? 
                                            <span className='fw-bold text-danger mx-1'>{lateCount}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    <span title={"Device Lock Alert Count"} style={{fontSize:"small"}}>
                                        {"| DL"} 
                                        {deviceLockedForAff > 0 ?
                                            <span className='fw-bold text-danger mx-1'>{deviceLockedForAff}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    <span title={"Driver Penalty Count"} style={{fontSize:"small"}}>
                                        {"| DP"} 
                                        {driverPenaltyCountForAff > 0 ? 
                                            <span className='fw-bold text-danger mx-1'>{driverPenaltyCountForAff}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    <span title={"Other Alerts Count"} style={{fontSize:"small"}}>
                                        {"| OT"} 
                                        {othersCount > 0 ? 
                                            <span className='fw-bold text-danger mx-1'>{othersCount}</span>
                                            :<span className='fw-bold text-white mx-1'>{0}</span>
                                        }
                                    </span>
                                    {/* <span className='text-center my-auto mx-1 p-1 circle' 
                                        style={{cursor:"pointer", width:"35px", height:"35px", backgroundColor:"white"}} title={"Click to open extension dialog"} 
                                        onClick={handleToggleDropdown}
                                        >
                                        <Icon icon="vaadin:headset" style={{ color:"black", width: "20px", height: "20px" }}/>
                                    </span> */}
                                
                                </span>
                  
                            <span
                                    className="text-center my-auto mx-1 p-1"
                                    style={{
                                        cursor: "pointer",
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: loginData.vExtension !== "" ? "rgb(40, 167, 69)" : "white",
                                        borderRadius: "8px", // soft edges (not round)
                                        display: "inline",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                    title= {loginData.vExtension == "" ? "Extension Not connected" : "Extension Connected"}
                                    onClick={handleToggleDropdown}
                                    >
                                    {loginData.vExtension == "" &&
                                        <HeadSetOffIcon
                                            style={{
                                                color: loginData.vExtension !== "" ? "white" : "red", // green when connected
                                                width: "20px",
                                                height: "20px",
                                                background: loginData.vExtension !== "" ? "rgb(40, 167, 69)" : "white"
                                                }}
                                        ></HeadSetOffIcon>
                                    }
                                    {loginData.vExtension !== "" &&
                                        <Icon
                                            icon="vaadin:headset"
                                            style={{
                                            color: loginData.vExtension !== "" ? "white" : "black", // green when connected
                                            width: "20px",
                                            height: "20px",
                                            background: loginData.vExtension !== "" ? "rgb(40, 167, 69)" : "white"
                                            }}
                                        />
                                    }
                                    </span>
                        </span>
                    );
                };

                setShowAlertsTitleHTML(alertsTitleHTML);
            }
        }
        catch(err){console.log(err);}
    };

    const DefaultEmptyAlerts = () => {
        let alertsTitleHTML = function (index) {
            return (
                
                <span key={index} style={{fontSize: "small"}}> 
                     {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Customer Management"} onClick={()=>{setShowCustomerManagement(true);}}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'ix:customer'}/> 
                    </span> */}
                    {renderDriverMdtMessagingIcon()}

                    {IsModuelAllowed_DriverRouteMessaging == true &&
                    (
                        <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                    style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver Route Messaging"} onClick={()=>{setShowRouteMessaging(true);}}
                                >
                                    <PermPhoneMsgIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                        </span>
                    )}
                    <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Robo Notification logs"} onClick={()=>{setshowNotifications(true);}}
                            >
                                <EditNotificationsIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                            </span>
                            
                    
                    <span className='text-dark bg-white small px-2 py-1' onClick={handleOpenAlerts} style={{cursor:'pointer', borderRadius: "10px"}}>{"ALERTS"}</span>
                    <span className='text-white mx-1 px-1 fw-normal'>
                        <span title={"Emergency Alert Count"} style={{fontSize: "small"}}>
                            {"| EM"} <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"No-Show Alert Count"} style={{fontSize: "small"}}>
                            {"| NS"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Late Pickup Alert Count"} style={{fontSize: "small"}}>
                            {"| LT"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Device Lock Alert Count"} style={{fontSize: "small"}}>
                            {"| DL"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Driver Penalty Count"} style={{fontSize: "small"}}>
                            {"| DP"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Other Alerts Count"} style={{fontSize: "small"}}>
                            {"| OT"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span className='text-center my-auto mx-1 p-1 circle' 
                        style={{cursor:"pointer", width:"35px", height:"35px", backgroundColor:"white"}} title={"Click to open extension dialog"} 
                        onClick={handleToggleDropdown}
                        >
                            <Icon icon="vaadin:headset" style={{ color:"black", width: "20px", height: "20px" }}/>
                        </span>
                    </span>
                </span>
            );
        };
        setShowAlertsTitleHTML(alertsTitleHTML);
    };

    const handleOpenAlerts = ()=>{
        
        if(Object.keys(UserLoginData.current)?.length > 0)
        {
            setShowDriverAlerts(true);
            if(AffiliateIDForAlertsRef.current && AffiliateIDForAlertsRef.current !== ''){
                handleShowAlertCounts(AffiliateIDForAlertsRef.current);
            }
        }
        else
        {
            setShowDriverAlerts(false);
        }
    };

    // Cross-window notification sync: listens for localStorage changes made by Messaging screen
    // Replaces previous recursive setTimeout polling which had no cleanup on unmount
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'notifIcon' || String(e.key ?? "").startsWith("DriverMsg_")) {
                refreshMessagingNotificationState();
            }
        };
        const handleLocalChange = () => {
            refreshMessagingNotificationState();
        };
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('messagingNotificationStateChange', handleLocalChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('messagingNotificationStateChange', handleLocalChange);
        };
    }, []);

    useEffect(() => {
        if(affSelected) {
            AffiliateIDForAlertsRef.current = parseInt(affSelected);
        }
    }, [affSelected]);

    useEffect(() => {
        try{
            const isCallAgent = window.location.href.toLowerCase().includes("callagent");
            const isMessaging = window.location.href.toLowerCase().includes("messaging");
            const isLoginEmpty = Object.keys(loginData)?.length === 0;
            if(isLoginEmpty || isCallAgent || isMessaging)
            {
                setShowAlertsTitleHTML(<span>{"ALERTS"}</span>);
                if(AlertsRef.current){
                    AlertsRef.current.className = "d-none";
                }
            }
            else
            {
                UserLoginData.current = loginData;

                if(AffiliateIDForAlertsRef.current && AffiliateIDForAlertsRef.current !== "" && AffiliateIDForAlertsRef.current !== 0)
                {
                    handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                }
                else {
                    DefaultEmptyAlerts();
                }
                
                if(AlertsRef.current){
                    AlertsRef.current.className = "m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 shadow user-select-none d-block";
                }
            }
        }
        catch(err){console.log(err);}
        const interval = setInterval(() => {
          if (Object.keys(UserLoginData.current)?.length > 0) {
            handleShowAlertCounts(AffiliateIDForAlertsRef.current);
          }
        }, 30000);
      
        // Clear interval on component unmount
        return () => clearInterval(interval);
    }, [loginData, notifIcon, notifCount]);

    useEffect(()=>{
        try{
            let resizeTimeout = 0;
            const handleResize = () =>{
                try{
                  clearTimeout(resizeTimeout); //clear if resizing continues
                  resizeTimeout = setTimeout(() => {
                    setWinWidth(window.innerWidth);
                  }, 100);
                }
                catch(err){console.log(err);}
            };

            if(document.readyState === 'complete') {
                let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);

                if(!AffiliateIDForAlertsRef.current && familySelectionMemory){
                    AffiliateIDForAlertsRef.current = parseInt(familySelectionMemory);
                    handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                }

            }
              
            window.addEventListener('resize', handleResize);

            return()=>{window.removeEventListener('resize', handleResize);}
        }
        catch(err){console.log(err);}
    }, []);

    useEffect(()=>{
        try{
            if(showMessaging){
                const resolvedAffiliate = resolveMessagingAffiliateId();
                if (resolvedAffiliate > 0) {
                    PersistStorage.save('passedAff', resolvedAffiliate, 9999, true);
                }
                window.open(`/Messaging`, 'com_domain_messagingScreen');
                setShowMessaging(false);
            }
        } catch(err){}
    }, [showMessaging]);

    useEffect(()=>{
        try{
            if(showRouteMessaging){
                const resolvedAffiliate = resolveMessagingAffiliateId();
                if (resolvedAffiliate > 0) {
                    PersistStorage.save('passedAff', resolvedAffiliate, 9999, true);
                }
                window.open(`/DriverRouteMessaging`, 'com_domain_routeMessagingScreen');
                setShowRouteMessaging(false);
            }
        } catch(err){}
    }, [showRouteMessaging]);

    useEffect(()=>{
        try{
            if(showNotifications){
                const resolvedAffiliate = resolveMessagingAffiliateId();
                if (resolvedAffiliate > 0) {
                    PersistStorage.save('passedAff', resolvedAffiliate, 9999, true);
                }
                window.open(`/Notificationlogs`, 'com_domain_routeNotificationScreen');
                setshowNotifications(false);
            }
        } catch(err){}
    }, [showNotifications]);

    useEffect(()=>{
        const resolvedAffiliate = resolveMessagingAffiliateId();
        if (resolvedAffiliate > 0) {
            const fetchData = async () => {
                try {
                  await updateDriverMsgs();
                } catch (err) {
                  console.error("Error updating driver messages:", err);
                }
              };
              fetchData();

            const interval = setInterval(() => {
                updateDriverMsgs().catch((err) => {
                    console.error("Error updating driver messages:", err);
                });
            }, 15000);

            return () => clearInterval(interval);
        }
    }, [affSelected, loginData?.UserAffiliateList, loginData?.iUserID]);

    useEffect(() => {
        // Check if notification permission is granted when the component mounts
        if (Notification.permission === "default") {
            setShowModal(true); // Show modal if permission is not granted
        }
        // Sync initial notifIcon state from localStorage on mount
        refreshMessagingNotificationState();
    }, []);

    const requestPermission = () => {
        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                setShowModal(false); // Close the modal if permission is granted
            } else {
                alert("Notifications not enabled.");
            }
        });
    };

    useEffect(()=>{
        try{
            if(showCustomerManagement){
                // PersistStorage.save('passedAff', parseInt(affSelected), 9999, true);
                window.open(`/CustomerManagement`, 'com_domain_CustomerManagement');
                setShowCustomerManagement(false);
            }
        } catch(err){}
    }, [showCustomerManagement]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
        // Check if click is on the dropdown itself or the toggle icon
        const isDropdownClick = dropdownRef.current?.contains(event.target);
        const isIconClick = event.target.closest('[title="Click to open extension dialog"]');
        
            if (showDropdown && !isDropdownClick && !isIconClick) {
                setShowDropdown(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

const handleConnectToAsteriskExtension = async() => {
            let data = {
            "Extension": asteriskExt,
            "SessionID": loginData.iSessionID
        };
        let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/UpdateExtensionForLoginInstance", "post", { "Content-Type": "application/json" }, data, null);
        if(response.error === "")
        {
            if(response.data.success === true)
            {
                dispatch(updateVExtension(asteriskExt));
                setAsteriskExtension('');
                setShowExtInput(false);
                //setShowExtInput(true);
                if(loginData.vExtension !== ""){
                    setShowExtButton(false);
                }
                else{
                    setShowExtButton(true);
                }
            }
            else{
                setShowExtButton(true);
            }
        }
        else{
            setAsteriskExtension('');
            setShowExtInput(false);
            setShowExtButton(true);
        }
        
    }


    const handleAsteriskExtension = (e) => {
        setAsteriskExtension(e.target.value);
    }

    const handleToggleDropdown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowDropdown(prev => !prev);
        if(loginData.vExtension !== ""){
            setShowExtInput(false);
            setShowExtButton(false);
        }
        else{
            setShowExtInput(false);
            setShowExtButton(true);
        }
    };
        


    async function updateDriverMsgs(){
        if (isFetchingRef.current) return;
        const resolvedAffiliateIds = resolveMessagingAffiliateIds();
        if (resolvedAffiliateIds.length === 0) {
            return;
        }
        isFetchingRef.current = true;
        setIsFetching(true);
        try{
            const toDateVal = 'now';
            let fromDateVal = 'today';
            const userID = String(loginData?.iUserID ?? -1);
            const affiliateList = resolvedAffiliateIds.join(",");
            const lastSeenMessageID = getLastSeenDriverMessageID(userID);

            if (loginData?.iUserID === undefined || loginData?.iUserID === null) {
                loginData.iUserID = -1;
            }

            let data = {
                atspid: resolvedAffiliateIds[0],
                affiliateList: affiliateList,
                newMessagePopupLastMessID: lastSeenMessageID,
                driverID: (""),
                vehicleID: String(-1),
                userID: 'LoginUser',
                dispatcherUserID: String(loginData.iUserID),
                deviceID: String(''),
                toDate: toDateVal,
                fromDate: fromDateVal,
                tillDate: (new Date()),
                lastMessID: lastSeenMessageID
            };

            const triggerHeaderNotification = (notification = {}) => {
                const vehNo = notification.VehicleNo ?? notification.vehicleNo ?? notification.NewMessageAlertVehNo ?? notification.newMessageAlertVehNo ?? "";
                const driverNo = notification.DriverNo ?? notification.driverNo ?? "";
                const affiliateID = notification.AffiliateID ?? notification.affiliateID ?? "";
                const affiliateName = notification.AffiliateName ?? notification.affiliateName ?? "";
                const messageID = notification.MessageID ?? notification.messageID ?? notification.iID ?? "";
                const normalizedVehNo = String(vehNo ?? "").trim();
                if (normalizedVehNo === "") {
                    return false;
                }

                try {
                    const activeDriverRaw = localStorage.getItem('activeMessagingDriver');
                    if (activeDriverRaw) {
                        const activeDriver = JSON.parse(activeDriverRaw);
                        if (
                            activeDriver &&
                            String(activeDriver.vehNo).trim() === normalizedVehNo &&
                            String(activeDriver.driverNo).trim() === String(driverNo).trim() &&
                            String(activeDriver.affiliateID).trim() === String(affiliateID).trim()
                        ) {
                            return false;
                        }
                    }
                } catch (err) {
                    console.error("Error reading activeMessagingDriver in header:", err);
                }

                setNotifIcon(true);
                setPendingDriverMessage({
                    affiliateID,
                    affiliateName,
                    vehNo: normalizedVehNo,
                    driverNo,
                    messageID
                });

                prevVeh.current = normalizedVehNo;

                return true;
            };

            let notificationHandled = false;

            const loadMsgResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadUnreadGeneralMessageNotifications", "post", {}, data, null);

            if(loadMsgResponse && loadMsgResponse.error.length === 0 ){
                const responseData = loadMsgResponse.data || {};
                const notifications = responseData.Notifications || responseData.notifications || [];
                const latestMessageID = parseInt(responseData.LatestMessageID ?? responseData.latestMessageID ?? -1, 10);

                if (latestMessageID > -1) {
                    lastMessID.current = latestMessageID;
                    setLastSeenDriverMessageID(userID, latestMessageID);
                }

                if (Array.isArray(notifications) && notifications.length > 0) {
                    const newestNotificationID = notifications.reduce((maxID, item) => {
                        const itemMessageID = parseInt(item.MessageID ?? item.messageID ?? item.iID ?? -1, 10);
                        return itemMessageID > maxID ? itemMessageID : maxID;
                    }, -1);

                    notifications.forEach((notification) => {
                        notificationHandled = triggerHeaderNotification(notification) || notificationHandled;
                    });

                    if (newestNotificationID > getLastSoundedDriverMessageID(userID)) {
                        if (Notification.permission === 'granted') {
                            var notifAudio = new Audio(MDT_notification);
                            notifAudio.play().catch((err) => {
                                console.error('Error playing notification audio:', err);
                            });
                        }
                        setLastSoundedDriverMessageID(userID, newestNotificationID);
                    }
                }
            }

            refreshMessagingNotificationState();
        }
        catch(err){console.log(err);}
        finally{
            isFetchingRef.current = false;
            setIsFetching(false);
            if(localStorage.getItem("notifIcon") === "false" && !hasAnyPendingDriverMessage()){
                setNotifIcon(false);
            }
        }
    }

    return (
        <>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enable Notifications</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>We would like to send you notifications for important updates. Please enable notifications for a better experience.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" style={{ backgroundColor: "#32728b", borderColor: "#32728b" }} onClick={requestPermission}>
                        Enable Notifications
                    </Button>
                </Modal.Footer>
            </Modal>

            <nav className="navbar fixed-top my-auto navbar-expand-lg w-100 page-header d-flex justify-content-between position-relative" style={{height:'50px'}}>
                <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none' alt="ITCurves" />
                {winWidth < 540 ? 
                    <span className='float-end text-end my-auto d-inline-flex' style={{cursor:"pointer"}} title={"Display Driver Alerts"} onClick={handleOpenAlerts}>
                        <Icon className='text-danger me-2 my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'oui:alert'}/> 
                    </span>
                    :
                    <p className='m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 HeaderAlertResponsive shadow user-select-none' 
                        ref={AlertsRef} title={"Display Driver Alerts"} style={{borderRadius:"10px"}}
                    >
                        {showAlertsTitleHTML}
                    </p>
                }
                <DriverAlerts selectedAff={AffiliateIDForAlertsRef.current} showDriverAlerts={showDriverAlerts} setShowDriverAlerts={setShowDriverAlerts}/>
                {/* {showMessaging ? <Messaging showMessaging={showMessaging} setShowMessaging={setShowMessaging} passedAff = {affSelected}/> : ''}  */}
            </nav>
            {showDropdown && (
                <div 
                    ref={dropdownRef}
                    className="user-dropdown-menu rounded"
                    style={{
                        position: 'absolute',
                        top: '50px', // Adjust based on your header height
                        right: '20px', // Adjust based on your layout
                        zIndex: 1050, // Ensure it appears above other elements
                        minWidth: '20%',
                        background: "#545454"
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div style={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            width: "100%",
                            paddingLeft: "5px",
                            paddingRight: "5px",
                            background: "#333333",
                            alignItems: "center"
                        }}>
                            <div style={{
                                display: "inline-flex",
                                alignItems: "center"
                            }}
                            title='Username'
                            >
                                <LoggedInPerson className='text-light my-auto' style={{width:"30px", minWidth:"30px", height:"30px", paddingRight: "5px"}}/>
                                <p style={{margin: "0px", paddingLeft: "3px", color: "white"}}>{loginData.vDisplayName}</p>
                            </div>

                        {/* <span style={{width:"10%"}}> */}
                        <div style={{
                                display: "inline-flex",
                                alignItems: "center"}}
                        >

                            {loginData.vExtension !== '' && 
                            
                                // <h6 className="text-light mb-0" title='Agent Phone Extension'>{loginData.vExtension} 
                                //     <small className="text-success">Connected</small>
                                // </h6>
                                <h6
                                    className="text-light mb-0 d-inline-flex align-items-center"
                                    title="Agent Phone Extension"
                                    style={{marginRight: "30px"}}
                                    >
                                    <span
                                        style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#28a745", // Bootstrap green
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginRight: "6px"
                                        }}
                                    />
                                    {loginData.vExtension}
                                </h6>
                            }

                            {showExtButton === true ? 
                                <Button variant="secondary" onClick={() => {setShowExtInput(true); setShowExtButton(false)}} style={{marginTop: "3px",marginBottom: "3px", background: "rgb(40, 167, 69)", marginRight: "5px"}} title='Add Phone Extension'>
                                    <Icon icon="material-symbols:add-call" className="me-1"
                                    style={{ width: "20px", height: "20px", color: "white" }}/>
                                </Button>
                                : ""
                            }

                            <Button variant="secondary" style={{marginTop: "3px",marginBottom: "3px", background: "seagreen"}} title='Click to download phone utility'>
                                <a href={PhoneUtilityDownloadLinkRef.current}>
                                    <DownloadPhoneUtitlity className='text-light my-auto' style={{width:"25px", minWidth:"25px", height:"20px"}}/>
                                </a>
                            </Button>
                        </div>
                    </div>
                    <div>
                        {/* <div className="user-avatar rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"> */}
                            {/* <a href={PhoneUtilityDownloadLinkRef.current} title='Click to download phone utility'>
                                <DownloadPhoneUtitlity className='text-light my-auto' style={{width:"30px", minWidth:"30px", height:"30px"}}/>
                            </a> */}
                            {/* <span title='Logged Username' style={{ width: "100%", height: "20px", fontSize:"smaller", textAlign:"left", marginLeft:"10px", fontStyle: "italic" }}>
                               {loginData.vDisplayName}</span> */}
                        {/* </div> */}
                        {/* {loginData.vExtension !== '' && (<h6 className="text-light mb-0" title='Agent Phone Extension'>{loginData.vExtension} <small className="text-success">Connected</small></h6>)} */}
                        {loginData.vExtension === '' && (
                            // <div className="d-flex align-items-center justify-content-center mx-auto">
                                showExtInput === true && 
                                    (
                                        <div className="input-group" style={{}}>
                                            <input
                                            id="254lj"
                                            name="extension"
                                            type="text"
                                            className="form-control text-center"
                                            placeholder="Enter your Extension.."
                                            maxLength={5}
                                            value={asteriskExt}
                                            onChange={handleAsteriskExtension}
                                            style={{ fontSize: "medium", fontStyle: "italic" }}
                                            />
                                        
                                            <Button
                                                // variant="primary"
                                                onClick={handleConnectToAsteriskExtension}
                                                title="Click to save extension"
                                                style={{
                                                    paddingRight: "10%",
                                                    textAlign: "center",
                                                    alignItems: "center",
                                                    paddingLeft: "10%",
                                                    background: "rgb(40, 167, 69)"
                                                }}
                                            >
                                            Connect
                                            </Button>
                                      </div>
                                    )
                            // </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );

};

export default HeaderComponent;
